// frontend/src/components/dashboard/services/settingService.js
import apiClient from '../../../api/client';

export const getSettings = async () => {
  try {
    const response = await apiClient.get('/api/v1/settings');
    // Parse JSON fields if they're strings (MySQL stores them as strings)
    return {
      ...response.data,
      paymentMethods: typeof response.data.payment_methods === 'string' 
        ? JSON.parse(response.data.payment_methods) 
        : response.data.payment_methods || [],
      notifications: typeof response.data.notifications === 'string'
        ? JSON.parse(response.data.notifications)
        : response.data.notifications || {}
    };
  } catch (error) {
    console.error('Error fetching settings:', error);
    throw error;
  }
};

export const updateSettings = async (settings) => {
  try {
    const response = await apiClient.put('/api/v1/settings', settings);
    return response.data;
  } catch (error) {
    console.error('Error updating settings:', error);
    throw error;
  }
};